import styled from 'styled-components';

export const StyledCartWidget = styled.div`
  position: relative;
  img {
    height: 2rem;
    margin-right: 1rem;
    width: 2rem;
  }
  span {
    background-color: #fadafa;
    border-radius: 50%;
    color: #817094;
    display: inline-block;
    font-size: 1rem;
    height: 1.5rem;
    position: absolute;
    right: 10%;
    text-decoration: none;
    width: 1.5rem;
  }
`;
